import { useState } from 'react';
import classNames from 'classnames/bind';
import { IFlightSearchHistory } from 'hooks/useHistory';
import Item from '../item';

import styles from '../index.module.scss';

const cx = classNames.bind(styles);

interface IProps {
  searchHistories: IFlightSearchHistory[];
  deleteHistoryFunc: (historyId: string) => Promise<any>;
}

function PC(props: IProps) {
  const { searchHistories, deleteHistoryFunc } = props;

  const [startIdx, setStartIdx] = useState(0);

  const totalCount = searchHistories.length;
  const displayCount = 3;

  const items = searchHistories.map((history, idx) => (
    <Item
      key={`${history.historyId}_${idx}`}
      history={history}
      deleteHistory={(historyId: string) => {
        deleteHistoryFunc(historyId);
        setStartIdx(prev => (prev > 0 ? prev - 1 : prev));
      }}
    />
  ));

  return (
    <>
      <ul className={cx('list_pc')}>
        {items.slice(startIdx, startIdx + displayCount)}
      </ul>
      {totalCount > displayCount && (
        <div className={cx('btns')}>
          {startIdx > 0 && (
            <button
              type="button"
              className={cx('prev')}
              onClick={() => setStartIdx(prev => prev - 1)}
            />
          )}
          {startIdx + displayCount < totalCount && (
            <button
              type="button"
              className={cx('next')}
              onClick={() => setStartIdx(prev => prev + 1)}
            />
          )}
        </div>
      )}
    </>
  );
}

export default PC;
